import type { RouteRecordRaw } from 'vue-router';

export const networkRoutes: RouteRecordRaw[] = [
  {
    path: '/network',
    name: 'Network',
    redirect: { name: 'MyNetworkConnections' },
    meta: {
      requiresAuth: true,
      navigation: {
        label: 'Network',
        icon: 'network-icon.svg',
        order: 4,
        showInMenu: true,
        permissions: {
          rbacRoles: ['networknav-read']
        }
      }
    },
    children: [
      {
        path: 'connections/',
        name: 'MyNetworkConnections',
        component: () => import("@/views/my_network/connections/Connections.vue"),
        props: {
          actionPermissions: ["connection-write", "connection-all"],
          viewPermissions: ["connection-read", "connection-all"],
          extraPermissions: ["connectioninvite-write", "connectionaccept-write"],
        },
        meta: {
          title: "Network - Connections",
          requiresAuth: true,
          navigation: {
            parent: 'Network',
            parentIcon: 'network-icon.svg',
            label: 'Connections',
            order: 1,
            showInMenu: true,
            permissions: {
              rbacRoles: ['connection-read', 'connection-all'],
              ownerRoles: ['Publisher', 'Retailer'],
              viewPermissions: ['connection-read', 'connection-all'],
              actionPermissions: ['connection-write', 'connection-all']
            }
          }
        }
      },
    ]
  },
  {
    path: "/my_network/connections-type-guid/:type/:guid",
    name: "MyNetworkConnectionsTypeGuid",
    component: () =>
      import(
        "@/views/my_network/connections-type-guid/ConnectionsTypeGuid.vue"
      ),
    props: { navigationUrl: "/mediakiwi/my_network/connections" },
    meta: {
      title: "Network - Connections",
      requiresAuth: true,
    },
  },
  {
    path: "/Relationship/:type/:guid",
    name: "MyNetworkRelationship",
    component: () =>
      import("@/views/my_network/relationship/Relationship.vue"),
    props: { navigationUrl: "/mediakiwi/my_network/relationship" },
    meta: {
      title: "My Network - Relationship",
      requiresVisitor: true,
      isPublic: true,
    },
  },
];